import { ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, Output, SimpleChanges, ViewChild } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { YouTubePlayer } from '@angular/youtube-player';
import { local } from 'd3';
import { DataService } from 'src/app/services/data.service';
import { DocTypeService } from 'src/app/services/doc-type.service';

@Component({
  selector: 'app-content-view',
  templateUrl: './content-view.component.html',
  styleUrl: './content-view.component.scss'
})
export class ContentViewComponent {
  @Input({ required: true }) contentType?: ContentViewTypes;
  @Input({ required: true }) source: any;
  @Input() courseId: string = '';
  @Input() session: any;
  @Input() blockingVideo: boolean = false;
  @Output() videoError: EventEmitter<boolean> = new EventEmitter()
  @Output() sessionUpdate: EventEmitter<any[]> = new EventEmitter()
  today: Date = new Date()

  extension: string = '';
  ytPlayer: any
  contentTypes = ContentViewTypes;
  defaultSeenTypes = [this.contentTypes.Doc,this.contentTypes.Excel,this.contentTypes.Image,this.contentTypes.Pdf,this.contentTypes.Text]

  intervalId: any;

  @Input() viewOnly: boolean = true;

  //Player state
  ticker: number = 0;
  previousTime: number = 0;

  constructor(
    private domSenitizer: DomSanitizer,
    private dataService: DataService,
    private cdr: ChangeDetectorRef,
    private route: ActivatedRoute,
    private docService: DocTypeService,
    private router: Router
  ) { }

  youtubePlayerReady(player: any) {
    this.ytPlayer = player
  }

  validSession() {
    let endDate = new Date(this.session.end_time)
    endDate.setDate(endDate.getDate() + 1)
    return this.today.getTime() <= endDate.getTime();
  }

  openCertificate() {
    let url, id;
    let queryParams: any = { courseId: this.courseId };
    url = `/assessment/certificate`;
    id = this.source.assessmentId
    if (url) {
      if (!this.viewOnly) {
        queryParams['userTesting'] = 1
      }
      this.router.navigate([url, id], { queryParams: queryParams })
    }
  }

  openAttempt() {
    console.log('SESSION DATA', this.session);
    let url, id;
    let queryParams: any = { courseId: this.courseId };

    if (this.contentType === this.contentTypes.Survey) {
        url = `/sa/survey/attempt`;
        id = this.source.surveyId;
    } else if (this.contentType === this.contentTypes.Assessment) {
        url = `/sa/assessment/attempt`;
        id = this.source.assessmentId;
    }

    if (url) {
        if (!this.viewOnly) {
            queryParams['userTesting'] = 1;
        }
        const queryString = new URLSearchParams(queryParams).toString();
        const fullUrl = `${url}/${id}?${queryString}`;
        window.open(fullUrl, '_blank');
    }
  }


  async openAddQuestion() {
    let url, id;
    let queryParams: any = { courseId: this.courseId };
    if (this.contentType == this.contentTypes.Survey) {
      url = `/survey/add-question`
      id = this.source.surveyId;
    } else if (this.contentType == this.contentTypes.Assessment) {
      let qBankId = await this.fetchData(this.source.assessmentId)
      if (!qBankId) {
        return;
      }
      url = `/assessment/add-question`
      id = this.source.assessmentId;
      queryParams['QBankId'] = qBankId
    }
    if (url) {
      this.router.navigate([url, id], { queryParams: queryParams })
      // window.open(window.location.protocol + '//' + window.location.host + url, "_blank");
    }
  }

  async fetchData(id: string) {
    try {
      let res = await this.dataService.getData(`assessment/id/${id}`);
      if (!res.error) {
        return res.data.questionBankId;
      }
      return null;
    } catch (e) {

    }
  }

  updateSafeUrl() {
    if (this.contentType == ContentViewTypes.Pdf) {
      this.source = this.docService.getSecuritySafeUrl(this.source)
    }
  }

  ngOnChanges(simpleChange: SimpleChanges) {
    console.log(simpleChange)
    if (simpleChange['contentType']) {
      this.contentType = simpleChange['contentType'].currentValue
    }
    if (simpleChange['source']) {

      this.source = simpleChange['source'].currentValue;
      this.ticker = 0;
      if (this.contentType == this.contentTypes.Video) {
        this.extension = this.getSourceExtension();
      }
    }
    this.updateSafeUrl()
    console.log('UPDATED SOURCE', this.source)
    this.previousTime = 0;
    clearInterval(this.intervalId);
    if (this.contentType && this.defaultSeenTypes.includes(this.contentType)) {
      this.saveVideoProgress();
    }
  }

  error(event: any) {
    this.contentType = this.contentTypes.Unsupported
    this.videoError.emit(true)
  }

  getSourceExtension() {
    let arr = this.source.split('.')
    return arr[arr.length - 1]
  }


  onStateChange(event: any, player: YouTubePlayer) {
    if (event.data === YT.PlayerState.PLAYING) {
      this.intervalId = setInterval(() => {
        const currentTime = this.ticker;
        const duration = player.getDuration();
        let completionPercentage = Math.floor((currentTime / duration) * 100);
        this.ticker += 1;
        if (completionPercentage > 70) {
          this.saveVideoProgress()
        }
      }, 1000);
    } else if (event.data === YT.PlayerState.PAUSED || event.data === YT.PlayerState.ENDED) {
      clearInterval(this.intervalId)
    }
  }

  onTimeUpdate(videoPlayer: HTMLVideoElement) {
    const currentTime = this.ticker;
    const duration = videoPlayer.duration;
    let completionPercentage = Math.floor((currentTime / duration) * 100);
    if (this.previousTime + 1 == Math.floor(videoPlayer.currentTime)) {
      this.ticker += 1;
    }
    this.previousTime = Math.floor(videoPlayer.currentTime);
    if (completionPercentage > 70) {
      this.saveVideoProgress()
    }
  }
  async saveVideoProgress() {
    if (this.blockingVideo) {
      let uid = localStorage.getItem('uid')
      let data = {
        _id: this.session._id,
        user_id: uid
      }
      if (!this.session.seenby || !this.session.seenby?.includes(uid)) {
        let res = await this.dataService.postData('session/add-seen-by', data, 'PUT')
        if (!res.error) {
          // Reset open calculation
          if (this.session.seenby) {
            this.session.seenby.push(uid)
          } else {
            this.session.seenby = [uid]
          }
          this.sessionUpdate.emit(this.session.seenby)
        }
      }
    }
  }
}


export enum ContentViewTypes {
  YTVideo,
  Video,
  Survey,
  Assessment,
  Pdf,
  Doc,
  Excel,
  Image,
  Unsupported,
  Text,
}
